import { PUSH_ROUTE } from "../../actions/ui/types";
/**
 * custom middleware to route on action dispatch.
 * @returns {function({dispatch: *}): function(*): function(*): *}
 */ function createRouterMiddleware() {
    return function() {
        return function(next) {
            return function(action) {
                var type = action.type;
                if (type === PUSH_ROUTE) {
                    var _action_payload = action.payload, history = _action_payload.history, route = _action_payload.route;
                    history.push(route);
                }
                return next(action);
            };
        };
    };
}
var routerMiddleware = createRouterMiddleware();
export default routerMiddleware;

//# sourceMappingURL=routerMiddleware.js.map